/* eslint-disable no-console */

import { Noti_getTopicName } from './Noti.getTopicName'
import { Plat_isCordova } from '../Plat/Plat.device'

export const Noti_unsubscribe = async () => {
    if (!Plat_isCordova()) return

    if (window.FCM == null) {
        console.warn('FCM failed to load')
        return
    }

    const topic = await Noti_getTopicName()
    await FCM.unsubscribeFromTopic(topic)
}
